import { render, staticRenderFns } from "./Direccion.vue?vue&type=template&id=5d5c78fa&"
import script from "./Direccion.vue?vue&type=script&lang=ts&"
export * from "./Direccion.vue?vue&type=script&lang=ts&"
import style0 from "./Direccion.vue?vue&type=style&index=0&id=5d5c78fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports